const buildStackValueTextWithStyle = (field) => {
  return { text: field.value.text, style: field.value.style }
}

const buildStackLabelTextWithStyle = (field) => {
  return { text: field.label.text, style: field.label.style }
}
const buildStackLabel = (value) => {
  return { text: value, bold: false }
}

const buildStackValue = (value) => {
  return { text: value, bold: true }
}

const buildStackLabelAndValue = (label, value, bold = true) => {
  return { text: `${label} ${value}`, bold: bold }
}

export const lineBreak = () => ({ text: '\n' })

export const buildStackWithMultipleValues = (data) =>
  data.map((field) => ({
    stack: [buildStackLabel(field.label), ...field.values.map(buildStackValue)],
    width: 'auto',
  }))

export const buildStacksWithStyle = (data) =>
  data.map((field) => ({
    stack: [buildStackLabelTextWithStyle(field), buildStackValueTextWithStyle(field)],
    width: 'auto',
  }))

export const buildStacks = (data) =>
  data.map((field) => ({
    stack: [buildStackLabel(field.label), buildStackValue(field.value)],
    width: field.width || 'auto',
  }))

export const buildColumn = (data) =>
  data.map((field) => ({
    stack: [buildStackLabelAndValue(field.label, field.value, field.bold)],
    width: field.width || 'auto',
  }))

export const buildHeaderTable = (headers) => {
  return headers.map((header) => ({
    text: header,
    style: 'tableHeader',
  }))
}

export const transformOrderListToString = (orderList, index) => {
  return {
    text: orderList.ol.length === 0 ? '' : orderList.ol[index],
    style: 'indent',
  }
}
